import React from 'react';
import styled from 'styled-components/macro';

const Wrapper = styled.figure(({ $top }: { $top: number }) => `
  position: absolute;
  top: ${$top}vh;

  transform: translateY(100rem);
  opacity: 0;
`);

const Container = React.forwardRef(({ top, style, children }: {
  top: number,
  style?: React.CSSProperties
  children: React.ReactNode
},
  ref?: React.ForwardedRef<HTMLElement>
) => (
  <Wrapper
    ref={ref}
    style={style}
    $top={top}
  >
    {children}
  </Wrapper>
));

export default Container;